<template>
  <v-row no-gutters class="testimonials-section-container">
    <v-col cols="12">
      <v-row no-gutters>
        <v-col cols="12" class="title-container">
          <h1>What do people say?</h1>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="testimonial" cols="12" md="4">
          <p>
            "As soon as I completed my will, I received an email, and it was
            ready to be signed.
            <span>I found the experience quick and easy!</span>"
          </p>
          <h2>-- Tumi Marota</h2>
        </v-col>

        <v-col class="testimonial second" cols="4">
          <p>
            "<span>My online experience was perfect,</span>" I completed my will
            in my own privacy and time. My will was reviewed in 72 hours."
          </p>
          <h2>-- Abulele Gumede</h2>
        </v-col>

        <v-col class="testimonial third" cols="4">
          <p>
            "The process of completing my will was so easy! The online service
            provided a step-by-step guide which
            <span>took less than 15 minutes</span> to complete, and the legal
            vetting process took less than a day."
          </p>
          <h2>-- Mark Davids</h2>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'TestimonialsSection',
  };
</script>

<style scoped lang="scss">
  .testimonials-section-container {
    background-color: #f6f6f6;
    padding-top: 69px;
    padding-left: 110px;
    padding-right: 110px;
    .title-container {
      display: flex;
      justify-content: center;
      margin-bottom: 72px;
      h1 {
        font-family: Montserrat;
        font-size: 28px;
        font-weight: 500;
        line-height: 34.13px;
      }
    }
    .testimonial {
      display: flex;
      flex-direction: column;
      padding: 42px;
      padding-top: 0px;
      padding-bottom: 0px;
      display: flex;
      text-align: center;
      p {
        font-family: Montserrat;
        font-size: 15.32px;
        font-weight: 400;
        line-height: 18.68px;
        margin-bottom: 11px;

        span {
          font-family: Montserrat;
          font-size: 15.32px;
          font-weight: 700;
          line-height: 18.68px;
          text-align: center;
        }
      }
      h2 {
        font-family: Montserrat;
        font-size: 15.32px;
        font-style: italic;
        font-weight: 700;
        line-height: 18.68px;
        margin-bottom: 106px;
      }
    }
  }
  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .testimonials-section-container {
      padding-top: 50px;
      padding-left: 16px;
      padding-right: 16px;

      .testimonial {
        padding-left: 0;
        padding-right: 0;
        h2 {
          margin-bottom: 53px;
        }
      }
      .testimonial.second {
        display: none;
      }
      .testimonial.third {
        display: none;
      }
    }
  }
</style>
